import { useRef } from "react";
import { useParams } from "react-router-dom";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";

import { useScenarioUpdateMutation } from "src/hooks";
import { useScenario } from "src/hooks/useScenario";
import { ScenarioForm, ScenarioFormData } from "src/forms/ScenarioForm";
import { isReadOnly } from "src/utils/permission.utils";

interface Props {
  onClose: () => void;
}

export function ScenarioEditPage(props: Props) {
  const { t } = useTranslation();
  const { scenarioId = "", caseId = "" } = useParams<{ caseId: string; scenarioId: string }>();
  const { data: scenario } = useScenario(scenarioId);

  const updateMutation = useScenarioUpdateMutation(caseId, scenarioId);

  // dirty data is the local only (unsaved) version of server data
  // const [dirtyData, setDirtyData] = useState<Partial<ScenarioMutationData>>();
  const formRef = useRef<FormikProps<ScenarioFormData> | null>(null);

  /**
   * Functions
   */
  // function isDirty() {
  //   return formRef.current?.dirty === true;
  // }

  function handleDiscardChanges() {
    // setDirtyData({});
  }

  async function handleSave(values: ScenarioFormData) {
    if (!scenario) return;
    return updateMutation.mutate({
      ...scenario,
      ...values,
    });
  }

  return render();

  function render() {
    if (!scenario) return null;

    return (
      <>
        <ScenarioForm
          key={scenario.id}
          title={t("label.scenarioDetails")}
          data={scenario}
          readOnly={isReadOnly(scenario.permissions.updateGeneralSettings)}
          isLoading={updateMutation.isLoading}
          onSubmit={handleSave}
          onClose={() => {
            handleDiscardChanges();
            props.onClose();
          }}
          errors={updateMutation.error?.response?.data}
          formRef={formRef}
        />

        {renderNavigationConfirm()}
      </>
    );
  }

  function renderNavigationConfirm() {
    return null;
    // <NavigationConfirm when={isDirty}>
    //   {({ onConfirm, onCancel }) => (
    //     <ConfirmUnsavedDialog
    //       open
    //       onDiscard={() => {
    //         handleDiscardChanges();
    //         onConfirm();
    //       }}
    //       onSave={() => {
    //         if (formRef.current?.isValid) {
    //           formRef.current?.handleSubmit();
    //           onConfirm();
    //         } else {
    //           onCancel();
    //         }
    //       }}
    //       onCancel={() => {
    //         onCancel();
    //       }}
    //     />
    //   )}
    // </NavigationConfirm>
  }
}
